import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delethreeLogin } from "@/api/loginConfig/deleThree";
import { getThreeData } from "@/api/loginConfig/getThreeList";
import addthreeLogin from "./components/addThreeLogin";
export default {
  name: "addThreeLogin",
  components: {
    addthreeLogin: addthreeLogin
  },
  data: function data() {
    return {
      dialog: false,
      typeValue: "",
      searchgames: [],
      tableData: [],
      page: 1,
      total: 0,
      pagSize: 10,
      num: "",
      form: {},
      id: "",
      obj: {}
    };
  },
  created: function created() {
    this.getType();
  },
  methods: {
    getType: function getType() {
      var _this = this;

      getThreeData().then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      });
    },
    addType: function addType() {
      this.dialog = true;
      this.$refs.addthree.init({}, 1);
    },
    editType: function editType(item) {
      this.dialog = true;
      this.$refs.addthree.init(item, 2);
    },
    deleType: function deleType(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delethreeLogin({
                  id: id
                }).then(function (res) {
                  _this2.getType();
                });

                _this2.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleSource: function handleSource(id) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.addPayType.init(id);
      });
    },
    changeShow: function changeShow(val) {
      this.dialog = val;

      if (this.dialog == false) {
        this.getType();
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getType();
    }
  }
};